(function () {
  'use strict';

  var DESKTOP = 990;

  function slugify(text, used) {
    var base = String(text)
      .toLowerCase()
      .replace(/[^\w؀-ۿ\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60) || 'section';

    var slug = base;
    var i = 2;
    while (used[slug]) {
      slug = base + '-' + i;
      i += 1;
    }
    used[slug] = true;
    return slug;
  }

  function init(root) {
    if (root.dataset.atocReady === '1') return;
    root.dataset.atocReady = '1';

    var content = document.querySelector('.article-template__content');
    var list = root.querySelector('[data-atoc-list]');
    var wrap = root.querySelector('.atoc__wrap');
    if (!content || !list || !wrap) return;

    var levels = root.getAttribute('data-levels') === 'h2h3' ? 'h2, h3' : 'h2';
    var min = parseInt(root.getAttribute('data-min') || '2', 10);
    var offset = parseInt(root.getAttribute('data-offset') || '90', 10);
    var mobileDropdown = root.getAttribute('data-mobile-dropdown') === 'true';
    var sticky = root.getAttribute('data-sticky') === 'true';

    var headings = Array.prototype.filter.call(
      content.querySelectorAll(levels),
      function (h) {
        return h.textContent.trim().length > 0;
      }
    );

    if (headings.length < min) {
      root.remove();
      return;
    }

    var used = {};
    var links = [];

    headings.forEach(function (h) {
      var text = h.textContent.trim();
      if (!h.id) h.id = slugify(text, used);
      else used[h.id] = true;

      var li = document.createElement('li');
      li.className = 'atoc__item atoc__item--' + h.tagName.toLowerCase();

      var a = document.createElement('a');
      a.className = 'atoc__link';
      a.href = '#' + h.id;
      a.textContent = text;

      li.appendChild(a);
      list.appendChild(li);
      links.push({ li: li, target: h });
    });

    if (!mobileDropdown) root.classList.add('atoc--nodropdown');
    root.hidden = false;

    /* Smooth scroll with a header offset, and keep the URL clean-ish. */
    list.addEventListener('click', function (e) {
      var a = e.target.closest('.atoc__link');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      if (!target) return;

      e.preventDefault();
      var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });

      if (history.replaceState) history.replaceState(null, '', '#' + id);

      if (window.innerWidth < DESKTOP && mobileDropdown) wrap.open = false;
    });

    /* ------------------------------------------------------------------
       JS pinning instead of position: sticky.

       CSS sticky silently dies if any ancestor clips overflow or carries a
       transform. This theme applies reveal animations while scrolling, so
       that condition can appear part way down the page. Measuring against a
       placeholder and switching to position: fixed avoids the whole issue.
       ------------------------------------------------------------------ */
    var spacer = document.createElement('div');
    spacer.className = 'atoc__spacer';
    spacer.setAttribute('aria-hidden', 'true');
    root.parentNode.insertBefore(spacer, root);

    var column = root.parentNode;
    var pinned = false;
    var stickyTop = parseInt(root.getAttribute('data-sticky-top') || '100', 10);
    var endGap = parseInt(root.getAttribute('data-end-gap') || '24', 10);
    var boundary = root.closest('.mainblog_part') || content.parentNode;

    function unpin() {
      if (!pinned) return;
      pinned = false;
      root.classList.remove('is-pinned');
      root.style.position = '';
      root.style.top = '';
      root.style.left = '';
      root.style.width = '';
      root.style.maxHeight = '';
      spacer.style.height = '0px';
    }

    function pin(top, left, width, maxH) {
      root.style.position = 'fixed';
      root.style.top = top + 'px';
      root.style.left = left + 'px';
      root.style.width = width + 'px';
      root.style.maxHeight = maxH + 'px';
      if (!pinned) {
        pinned = true;
        root.classList.add('is-pinned');
      }
    }

    function update() {
      if (!sticky || window.innerWidth < DESKTOP) {
        unpin();
        return;
      }

      var anchorRect = spacer.getBoundingClientRect();
      var colRect = column.getBoundingClientRect();
      var height = root.offsetHeight;
      var maxH = window.innerHeight - stickyTop - 20;

      if (anchorRect.top > stickyTop) {
        unpin();
        return;
      }

      /* Stop at the end of the article row so the panel never rides over
         the footer: once the boundary rises past the panel's resting spot,
         the panel travels up with it instead of holding at stickyTop. */
      var boundaryBottom = boundary.getBoundingClientRect().bottom - endGap;
      var top = Math.min(stickyTop, boundaryBottom - Math.min(height, maxH));

      if (boundaryBottom <= 0) {
        unpin();
        return;
      }

      if (!pinned) spacer.style.height = height + 'px';
      pin(top, colRect.left, colRect.width, maxH);
    }

    /* Highlight the section currently under the header. */
    var ticking = false;
    function frame() {
      ticking = false;
      update();

      /* Viewport coordinates on both sides. offsetTop is measured from the
         nearest positioned ancestor, not the document, so mixing it with
         pageYOffset put the highlight several headings out. */
      var line = offset + 4;
      var current = null;
      links.forEach(function (entry) {
        entry.li.classList.remove('is-active');
        if (entry.target.getBoundingClientRect().top <= line) current = entry;
      });
      if (!current && links.length) current = links[0];
      if (current) current.li.classList.add('is-active');
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    /* Desktop: always expanded. Mobile: collapsed dropdown if enabled. */
    var placeholder = document.createComment('atoc');
    var home = root.parentNode;
    home.insertBefore(placeholder, root);

    function place() {
      var isDesktop = window.innerWidth >= DESKTOP;
      wrap.open = isDesktop ? true : !mobileDropdown;

      if (isDesktop) {
        if (root.parentNode !== home) {
          placeholder.parentNode.insertBefore(root, placeholder);
          home.insertBefore(spacer, root);
        }
        spacer.style.display = '';
      } else {
        unpin();
        spacer.style.display = 'none';
        if (content.parentNode && root.parentNode === home) {
          content.parentNode.insertBefore(root, content);
        }
      }
      update();
    }

    place();
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        unpin();
        place();
      }, 150);
    });

    frame();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-atoc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target); });
})();
